import m from "./../../../dist/es2015/locales/bg_BG.js";
export const am5locales_bg_BG = m;